import { client } from 'util/sdk';

// eslint-disable-next-line import/prefer-default-export
export const load = ({ fspId, userId, payerId }) =>
  client
    .fsps(fspId)
    .users(userId)
    .otpInfo(payerId ? { payerId } : undefined);
